var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTryMyPriceInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.1542L12 16.9542M12 8.59639V8.5542M2.39999 12.1542C2.39999 6.85226 6.69806 2.5542 12 2.5542C17.3019 2.5542 21.6 6.85227 21.6 12.1542C21.6 17.4561 17.3019 21.7542 12 21.7542C6.69806 21.7542 2.39999 17.4561 2.39999 12.1542Z",
    stroke: "#F9009E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryMyPriceInfo);
export default __webpack_public_path__ + "static/media/TryMyPriceInfo.e98c4a18d3ba7e3406f557a4a3c9da8c.svg";
export { ForwardRef as ReactComponent };